export default __webpack_public_path__ + "static/media/karmicBalance_sample.a752711f.jpg";